import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import HowItWorks from './pages/HowItWorks';
import Contact from './pages/Contact';
import About from './pages/About';
import ScrollToTop from './components/ScrollToTop';
import TermsAndConditions from './pages/TermsAndConditions';
import RxCompass from './pages/RxCompass';
import MedVed from './pages/MedVed';
import Liviniti from './pages/Liviniti';
import TrueScripts from './pages/TrueScripts';
import ScriptSourcing from './pages/ScriptSourcing';
import MaxCareRX from './pages/MaxCareRX';
import MakoRX from './pages/MakoRX';
import NotFound from './pages/NotFound';
// import Lucyrx from './pages/Lucyrx';
import LucyrxGuides from './pages/LucyRxGuides';
import HydroGear from './pages/HydroGear';
import PBM from './pages/PBMServices';
import SecureDownload from './pages/SecureDownload';
import ProactiveRX from './pages/ProactiveRX';

function App() {
  return (
    <Router>
      <Navbar />
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/how-it-works" element={<HowItWorks />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/termsandconditions" element={<TermsAndConditions />} />
        <Route path="/rxcompass" element={<RxCompass />} />
        <Route path="/medved" element={<MedVed />} />
        <Route path="/liviniti" element={<Liviniti />} />
        <Route path="/truescripts" element={<TrueScripts />} />
        <Route path="/scriptsourcing" element={<ScriptSourcing />} />
        <Route path="/maxcarerx" element={<MaxCareRX />} />
        <Route path="/makorx" element={<MakoRX />} />
        {/* <Route path="/lucyrx" element={<Lucyrx />} /> */}
        <Route path="/lucyrxguides" element={<LucyrxGuides />} />
        <Route path="/hydro-gear" element={<HydroGear />} />
        <Route path="/pbmservices" element={<PBM />} />
        <Route path="/secure-download" element={<SecureDownload />} />
        <Route path="/proactiverx" element={<ProactiveRX />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
